import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import SEO from "@/components/SEO";
import { Section, PrimaryButton } from "@/components/ui-helpers";
import { api } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setPost(null); setNf(false); api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setNf(true)); }, [slug]);
  if (nf) return <Section><h1 className="font-display text-2xl text-white">Post not found</h1><div className="mt-4"><PrimaryButton to="/blog">Back to guide</PrimaryButton></div></Section>;
  if (!post) return <div className="container-ascendia py-32 text-center text-muted-c">Loading…</div>;
  return (
    <>
      <SEO title={post.title} description={post.excerpt} />
      <section className="relative overflow-hidden border-b border-[color:var(--border-subtle)]">
        <img src={post.cover} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/70 to-[#0B0B0C]" />
        <div className="container-ascendia relative py-20">
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-gold-soft hover:text-gold"><ArrowLeft className="h-4 w-4" /> The Ascendia Guide</Link>
          <span className="mt-6 block text-[11px] uppercase tracking-[0.16em] text-gold-soft">{post.category}</span>
          <h1 className="mt-3 font-display text-3xl sm:text-4xl font-semibold text-white max-w-3xl">{post.title}</h1>
          <p className="mt-4 text-sm text-muted-c flex items-center gap-1"><Clock className="h-4 w-4" /> {post.read_time} · {post.date}</p>
        </div>
      </section>
      <Section>
        <article className="max-w-[68ch] mx-auto">
          {(post.content || "").split("\n\n").map((para, i) => <p key={i} className="mb-5 text-secondary leading-relaxed">{para}</p>)}
          <div className="gold-hairline my-10" />
          <div className="ascendia-card p-7 text-center">
            <h3 className="font-display text-xl font-semibold text-white">Want Ascendia to handle it?</h3>
            <p className="mt-2 text-secondary">Get a tailored quote based on your property's size, condition and scope.</p>
            <div className="mt-5 flex justify-center"><PrimaryButton to="/contact">Request a Quote</PrimaryButton></div>
          </div>
        </article>
      </Section>
    </>
  );
}
